const choices = {
    lessThanTen: 'Moins de 10%',
    betweenTenAndFifty: 'Entre 10 et 20%',
    betweenTwentyAndFifty: 'Entre 20 et 50%',
    moreThanFifty: 'Plus de 50%',
};

export default choices;
